import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '@/components/Account/Login.vue'
import Admin from '@/components/Home'
const taskList = () => import('@/components/TaskList')
const apiList =() =>import('@/components/ApiList')
import store from '@/store/index.js';

Vue.use(VueRouter)


const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/index',
    children:[
      {
        path:'/index',
        name:'Homepage',
        component:()=>import("../views/HomePage.vue"),
        meta:{
          keepAlive:false
        }
      },
      {
        path: '/billdetail',
        name: 'Billdetail',
        component: () => import('../views/BillDetail.vue'),
        meta:{
          keepAlive:false
        }
      },
      {
        path: '/mybill',
        name: 'Mybill',
        component: () => import('../views/MyBill.vue'),
        meta:{
          keepAlive:false
        }
      },
      {
        path: '/billhead',
        name: 'Billhead',
        component: () => import('../views/BillHead.vue'),
        meta:{
          keepAlive:false
        }
      },
      {
        path: '/makeinvoice',
        name: 'Makeinvoice',
        component: () => import('../views/MakeInvoice.vue'),
        meta:{
          keepAlive:false
        }
      },
      
      {
        path: '/updatainvoice',
        name: 'Updatainvoice',
        component: () => import('../views/UpdataInvoice.vue'),
        meta:{
          keepAlive:false
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isAnthenticated: false
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: {
      isAnthenticated: true
    },
    children:[
      {
        path: '/api/list',
        name: 'api',
        component: apiList,
        meta: {
          isAnthenticated: true
        },
      },
      {
        path: '/task/list',
        name: 'task',
        component: taskList,
        meta: {
          isAnthenticated: true
        },
      }
    ]
  }
  
]
const router = new VueRouter({
  routes,
 
})
// router.beforeEach((to, from, next) => {
//   // to 将要访问的路径
//   // from 从哪个路径跳转而来
//   // next 是一个函数，表示放行
//   //    next()  放行    next('/login')  强制跳转
//   let flag = localStorage.getItem('Flag')
//   if (to.path === '/admin'){
//     if(flag){
//       return next({
//         path:'/admin'
//       })
//     }else{
//       return next({
//         path:'/login'
//       })
//       localStorage.setItem('Flag',true)
//     }
    
    
//   } else{
//     return next()
//   }
  
// })
export default router
